import { ethers } from "ethers";
import {get, set, readable, writable} from 'svelte/store';
import {
    provider,
    signer,
    address as myAddress,
    unlock,
    unlocked,
    onWalletChange,
    correct_network,
    wallet_injected, onUnlocked,
    target_mainnet
} from "./wallet.js";
import {getAvailableConfigs} from "./configs";

// export let contractAddress = { //rinkeby
//     // molecules: "0x3918C14c7f029A17e3baC5a6587D95Cb494683e2", //og correct
//     molecules: "0xE1bB533A7F211BB396293bA17b39A1F293cbE889", //last pass
//
//     // molecules: "0x3e0b7D3A8eACe84ec613617a6556bF23f2811978",
//     pownft: "0xEd6dc1eE794204Db416F861613AC761F3fab11B2",
// }
// export let contractAddress = { //ropsten
//     molecules: "0x3ffFF45EA628700167d08E6C2ab19Cc311C38f4f",
//     pownft: "0xC49f072849dc72694E1E29425E55A7D69ed3437b",
// }
// export let contractAddress = { //gananche
//     molecules: "0x73D62Cc4D982E4120a12eE690E07B484AD013aBa",
//     pownft: "0x836696b9A6Af06771EBa6b697ce12AF80443cb76",
// }

export let contractAddress = { //mainnet
    molecules: "0xa96c108827674d6a08ed981477b7737495a9c547",
    pownft: "0x9abb7bddc43fa67c76a62d8c016513827f59be1b",
}

const MAINNET = {
    molecules: "0xa96c108827674d6a08ed981477b7737495a9c547",
    pownft:  "0x9abb7bddc43fa67c76a62d8c016513827f59be1b",
}

const ZERO =    "0x0000000000000000000000000000000000000000";


// export let first_block = 8859000;
// export let first_block = 10666767;
// export let first_block = 0;

// export const correctAddress = contractAddress.drops === MAINNET.drops;
export const correctAddress = true;//

export const contractAbi = {
    pownft: ["event Approval(address indexed _owner,address indexed _approved,uint256 indexed _tokenId)","event ApprovalForAll(address indexed _owner,address indexed _operator,bool _approved)","event Migrate(uint256 indexed _tokenId)","event Mined(uint256 indexed _tokenId,bytes32 hash)","event Transfer(address indexed _from,address indexed _to,uint256 indexed _tokenId)","event Withdraw(uint256 indexed _tokenId,uint256 value)","function PREV_CHAIN_LAST_HASH() view returns(bytes32 )","function UNMIGRATED() view returns(uint256 )","function V2_TOTAL() view returns(uint256 )","function approve(address _approved,uint256 _tokenId) nonpayable","function balanceOf(address _owner) view returns(uint256 )","function getApproved(uint256 _tokenId) view returns(address )","function hashOf(uint256 _tokenId) view returns(bytes32 )","function isApprovedForAll(address _owner,address _operator) view returns(bool )","function migrate(uint256 _tokenId,uint256 _withdrawEthUntil) nonpayable","function migrateMultiple(uint256[] _tokenIds,uint256[] _withdrawUntil) nonpayable","function mine(uint256 nonce) payable","function name() view returns(string _name)","function ownerOf(uint256 _tokenId) view returns(address )","function safeTransferFrom(address _from,address _to,uint256 _tokenId) nonpayable","function safeTransferFrom(address _from,address _to,uint256 _tokenId,bytes data) nonpayable","function setApprovalForAll(address _operator,bool _approved) nonpayable","function supportsInterface(bytes4 interfaceID) view returns(bool )","function symbol() view returns(string _symbol)","function tokenByIndex(uint256 _index) view returns(uint256 )","function tokenOfOwnerByIndex(address _owner,uint256 _index) view returns(uint256 )","function tokenURI(uint256 _tokenId) view returns(string )","function totalSupply() view returns(uint256 )","function transferFrom(address _from,address _to,uint256 _tokenId) nonpayable","function withdraw(uint256 _tokenId,uint256 _withdrawUntil) nonpayable","function withdrawMultiple(uint256[] _tokenIds,uint256[] _withdrawUntil) nonpayable"],
    molecules:  [

        "function claim(uint[] _atomIds) nonpayable",

        // "function readConfig(uint8[]  _composition) view returns(uint8[32])",

        "function moleculeOf(uint _tokenId) view returns(string)",
        "function checkFormula(uint8[] _composition) view returns(string)",
        "function myAtoms(uint start_index, uint limit) view returns(uint[] tokenIds, uint8[] atomicNumbers)",
        "function myMolecules(uint start_index, uint limit) view returns(uint[] tokenIds, string[] formulas)",
    ],
}


let contract = {
    molecules: null,
    pownft:  null,
}
let contractWithSigner = {
    molecules: null,
    pownft:  null,
}
export let me;

const BN = ethers.BigNumber;

export let state = writable('initial'); //initial, loading, loaded, network, error

export function cleanAddress(address){
    return String(address).toLowerCase();
}

const transactions = {
    // hash:{
    //     status: "pending",
    //     func: "purchase", //purchase
    //     params: {},
    // }
}

export let _pending = false;
export let _requested = false;

export let pending = writable(_pending);
export let requested = writable(_requested);

export let _atoms = {
    state: "initial",   //initial, loading, loaded, error
    tokenIds: [],
    atomicNumbers: [],
};
export let _molecules = {
    state: "initial",   //initial, loading, loaded, error
    tokenIds: [],
    formulas: [],
};



// {
//     state: "initial", //initial, loading, loaded, error
//     list: [],
// };


export let atoms     = writable(_atoms);
export let molecules = writable(_molecules);
export let available = writable([
    //{
    // atoms: pickAtomsForMolecule(atomicNumbers,tokenIds,_config),
    // configs: _config,
    // formula: _formula,
    // count: 0,
    //}
]);

export async function updateMyAtoms(){
    _atoms.state = "loading";
    _atoms.tokenIds = [];
    _atoms.atomicNumbers = [];

    atoms.set(_atoms);

    // console.log(await POWNFT_balanceOf(me));

    try{
        let _myAtoms = await myAtoms();
        _atoms.tokenIds      = _myAtoms.tokenIds;
        _atoms.atomicNumbers = _myAtoms.atomicNumbers;
        _atoms.state = "loaded";
    }catch(e){
        _atoms.state = "error";
        console.log(e);
    }
    atoms.set(_atoms);
    updateAvailable();
}
export async function updateMyMolecules(){
    _molecules.state = "loading";
    _molecules.tokenIds = [];
    _molecules.formulas = [];

    molecules.set(_molecules);

    try{
        let _myMolecules = await myMolecules();
        _molecules.tokenIds = _myMolecules.tokenIds;
        _molecules.formulas = _myMolecules.formulas;
        _molecules.state = "loaded";
    }catch(e){
        _molecules.state = "error";
        console.log(e);
    }
    molecules.set(_molecules);
    updateAvailable();
}

function updateAvailable(){
    let _available = getAvailableConfigs(_atoms.atomicNumbers,_atoms.tokenIds);
    for(let i = 0; i < _available.length; i++){
        if(_molecules.formulas.includes(_available[i].formula) ){
            _available[i].count++;
        }
    }
    available.set(_available);
}

async function POWNFT_balanceOf(address) {
    return await contract.pownft.balanceOf(address);
}

async function moleculeOf(_tokenId) {
    return await contract.molecules.moleculeOf(_tokenId);
}
export async function checkFormula(_composition) {
    return await contract.molecules.checkFormula(_composition);
}
export async function readConfig(_composition) {
    //readConfig(uint8[] calldata _composition) public view returns(uint8[32] memory)
    return await contract.molecules.readConfig(_composition);
}

async function myAtoms() {
    return await contractWithSigner.molecules.myAtoms(0,0);
}
async function myMolecules() {
    return await contractWithSigner.molecules.myMolecules(0,0);
}


export async function claim(_tokenIds){
    if(_requested || _pending) return;
    request_transaction();

    try{
        const tx =  await contractWithSigner.molecules.claim(_tokenIds);
        register_transaction(tx);
        await tx.wait();
        clear_transaction();
    }catch(e){
        cancel_transaction();
        alert_error(e);
        return false;
    }

    await updateMyMolecules();
}

// export async function updateMyPosters(){
//     _myPosters.state = "loading";
//     myPosters.set(_myPosters);
//
//     let _claimed;
//     try{
//         _claimed = await claimed();
//         _myPosters.list = _claimed;
//         _myPosters.state = "loaded";
//     }catch(e){
//         _myPosters.state = "error";
//     }
//     myPosters.set(_myPosters);
// }
// export async function updateMyUnclaimed(){
//     _myUnclaimed.state = "loading";
//     myUnclaimed.set(_myUnclaimed);
//
//     let _unclaimed;
//     try{
//         _unclaimed = await unclaimed();
//         _myUnclaimed.list = _unclaimed;
//         _myUnclaimed.state = "loaded";
//     }catch(e){
//         _myUnclaimed.state = "error";
//     }
//     myUnclaimed.set(_myUnclaimed);
// }
//
//
// export async function claimPosters(_count){
//     if(!_count || _count > _myUnclaimed.list.length){
//         //fail
//     }
//
//     if(_count === 1){
//         // console.log(">>>",_myUnclaimed.list[0].toString());
//
//         let owner = await ownerOfCat(_myUnclaimed.list[0].toString());
//         // console.log("??>",owner);
//
//
//         await claim(_myUnclaimed.list[0].toString());
//     }else{
//         let _toClaim = [];
//         for(let i = 0; i < _count; i++){
//             _toClaim.push( _myUnclaimed.list[i].toString());
//         }
//         // console.log(">>>",_toClaim);
//         await claimMultiple(_toClaim);
//     }
//
//     await updateMyUnclaimed();
//     await updateMyPosters();
// }
//
// async function unclaimed() {
//     return  await contractWithSigner.posters.unclaimed();
// }
// async function claimed() {
//     return await contractWithSigner.posters.claimed();
// }
// async function claimable(_tokenId) {
//     return await contract.posters.claimable(_tokenId);
// }
//
// async function ownerOfCat(_tokenId) {
//     return await contract.stonerCats.ownerOf(_tokenId);
// }

const parsed_events = {};

const callbacks = {
    Transfer:       [],

    transaction: {
        Submit: [],
        Confirm: [],
        Fail: [],
        Cancel: [],
    },
}

export function onTransfer(callback){
    callbacks.Transfer.push(callback);
}
export function onTransactionSubmit(callback){
    callbacks.transaction.Submit.push(callback);
}
export function onTransactionConfirm(callback){
    callbacks.transaction.Confirm.push(callback);
}
export function onTransactionFail(callback){
    callbacks.transaction.Fail.push(callback);
}
export function onTransactionCancel(callback){
    callbacks.transaction.Cancel.push(callback);
}

function transactionSubmitted(func,params){
    for(let i = 0; i < callbacks.transaction.Submit.length; i++){
        callbacks.transaction.Submit[i](func,params);
    }
}
function transactionConfirmed(func,params){
    for(let i = 0; i < callbacks.transaction.Confirm.length; i++){
        callbacks.transaction.Confirm[i](func,params);
    }
}
function transactionFailed(func,params){
    for(let i = 0; i < callbacks.transaction.Fail.length; i++){
        callbacks.transaction.Fail[i](func,params);
    }
}
function transactionCancelled(func,params){
    for(let i = 0; i < callbacks.transaction.Cancel.length; i++){
        callbacks.transaction.Cancel[i](func,params);
    }
}


function Transferred(_from,_to,_tokenId){
    for(let i = 0; i < callbacks.Transfer.length; i++){
        callbacks.Transfer[i](_from,_to,_tokenId);
    }
}





function parse_Transfer(_from,_to,_tokenId){
    if(_from === me){

    }
    if(_to === me){

    }

    if(get(state) === "loaded"){
    }

    Transferred(_from,_to,_tokenId);
}

function clear_transaction(){

    _pending = false;
    pending.set(_pending);
    transactionConfirmed();


}


function parse_event(event){
    if(typeof event === "undefined") {
        return;
    }

    const index = event.logIndex+event.transactionHash.substr(1,12);

    if(parsed_events[index]) {
        return;
    }
    parsed_events[index] = true;

    if(transactions[event.transactionHash]){
        clear_transaction(event.transactionHash);
    }

    switch (event.event){
        case "Transfer":
            parse_Transfer(
                cleanAddress(event.args._from),
                cleanAddress(event.args._to),
                Number(event.args._tokenId._hex)
            );
            break;
        default:
            // console.log("Other event:",event.event);

            break
    }
}
export async function connect(){
    state.set('loading');

    contract.molecules = new ethers.Contract(contractAddress.molecules,contractAbi.molecules,provider);
    contract.pownft    = new ethers.Contract(contractAddress.pownft,contractAbi.pownft,provider);

    contractWithSigner.molecules = contract.molecules.connect(signer);
    contractWithSigner.pownft  = contract.pownft.connect(signer);

    me = cleanAddress(get(myAddress));



    // for(let i = 1 ; i < 118; i++){
    //     for(let j = 1; j < 118; j++){
    //         let k = await readConfig([i,j]);
    //         if(k[0] !== 0){
    //             console.log(k);
    //         }
    //     }
    // }

    // console.log(await contract.pownft.balanceOf(me));



    console.log('load my atom and molecule data');

    await updateMyAtoms();
    await updateMyMolecules();


    state.set('loaded');
}

function reset(){
    console.log("injected reset")


    _pending = false;
    pending.set(_pending);

    _requested = false;
    requested.set(_requested);

    for(let tx in transactions){
        delete transactions[tx];
    }

    for(let evt in parsed_events){
        delete parsed_events[evt];
    }
}


//Function

function cancel_transaction(){
    _requested = false;
    requested.set(_requested);

    transactionCancelled();
}
function request_transaction(){
    _requested = true;
    requested.set(_requested);
}
function register_transaction(tx){
    _requested = false;
    _pending = true;

    pending.set(_pending);
    requested.set(_requested);

    transactionSubmitted();

    await_failure(tx.hash);
}

const await_failure = async(hash) => {
    const failure = (await provider.waitForTransaction( hash )).status === 0;
    if(failure){
        fail_transaction(hash);
    }
}

function fail_transaction(hash){
    transactionFailed(transactions[hash].func,transactions[hash].params);

    _pending = false;
    pending.set(_pending);
}


function alert_error(e){
    switch(e.code){
        case 4001:
            ///cancel
            break;
        //TODO: default?
        case "INSUFFICIENT_FUNDS":
            alert("You don't have enough ETH to make this transaction");
            break;
        default:
            if(e.message.includes("execution reverted: difficulty")){
                alert("Error: Your mining result is no longer valid and your transaction will fail.");
            }else{
                alert("Metamask error: "+e.message);

            }
            break;

    }
}

async function unlockCallback(){
    if(!get(correct_network)){
        state.set("network");
    }else{
        await connect();
    }

    onWalletChange(async (correctNetwork)=>{
        reset();
        if(!correctNetwork){
            state.set("network");
        } else{
            await connect();
        }
    });
}

export default async function init() {
    if(typeof window.ethereum === "undefined"){
        console.log('not injected')
        return;
    }
    console.log('injected')

    onUnlocked(unlockCallback);

    await unlock();
}


init();